var React = require('react');

function FooterOrnamentInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M321.578 7.00149L0.578125 7.00007","stroke":"white","key":0}),React.createElement("path",{"d":"M664.922 7.00149L343.922 7.00007","stroke":"white","key":1}),React.createElement("path",{"d":"M8.57812 12.7505L326.578 12.7519L338.079 1.25121L655.578 1.25122","stroke":"white","key":2}),React.createElement("path",{"d":"M655.5 12.7519L338.576 12.7519L327.075 1.25121L9.07556 1.25121","stroke":"white","key":3})]);
}

FooterOrnamentInline.defaultProps = {"width":"665","height":"14","viewBox":"0 0 665 14","fill":"none"};

module.exports = FooterOrnamentInline;

FooterOrnamentInline.default = FooterOrnamentInline;
